import React from 'react';

export default function ComparisonSection() {
  return (
    <section className="comparison-section" aria-labelledby="comparison-title">
      <div className="comparison-wrap">
        <div className="comparison-header">
          <div>
            <div className="eyebrow">Feature comparison</div>
            <h2 id="comparison-title">
              Poppy Poker: <span>Run Poker Nights!</span>
            </h2>
            <p className="comparison-intro">
              See how Poppy Poker compares with popular poker timer and tournament apps.
            </p>
          </div>

          <div className="legend" aria-label="Comparison key">
            <span><i className="mark yes">✓</i> Supported</span>
            <span><i className="mark limited">•</i> Limited</span>
            <span><i className="mark no">–</i> Not available</span>
          </div>
        </div>

        <div
          className="comparison-scroll"
          role="region"
          aria-label="Scrollable feature comparison table"
          tabIndex={0}
        >
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th className="brand-col">
                  Poppy Poker
                  <span className="competitor-note">Run poker nights. Automatically.</span>
                </th>
                <th>
                  Blinds Are Up
                  <span className="competitor-note">Popular timer app</span>
                </th>
                <th>
                  Poker Timer Pro
                  <span className="competitor-note">Simple timer app</span>
                </th>
                <th>
                  Poker Clock
                  <span className="competitor-note">Basic free timer</span>
                </th>
                <th>
                  Tournament Director
                  <span className="competitor-note">Advanced tournament tool</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="feature-group"><td colSpan={6}>Core Game Functionality</td></tr>
              <tr>
                <td>Poker Timer &amp; Blind Levels</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>
              <tr>
                <td>Custom Structures</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>
              <tr>
                <td>Breaks Support</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>
              <tr>
                <td>Pause / Resume</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>

              <tr className="feature-group"><td colSpan={6}>Sync &amp; Multi-Device</td></tr>
              <tr>
                <td>Real-Time Sync Across Devices</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>One Host, Many Viewers</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>No Setup Join</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Multi-Device Viewing</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>

              <tr className="feature-group"><td colSpan={6}>Discovery &amp; Social</td></tr>
              <tr>
                <td>Find Local Games (GPS)</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Game Discovery Feed</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Venue System</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Join Nearby Games</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>

              <tr className="feature-group"><td colSpan={6}>Advanced Poker Tools</td></tr>
              <tr>
                <td>ICM Calculator</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark limited">•</i></td>
              </tr>
              <tr>
                <td>Chip Chop</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Deal Negotiator</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Leave Money to Play For</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>

              <tr className="feature-group"><td colSpan={6}>Results &amp; Tracking</td></tr>
              <tr>
                <td>Record Results</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>
              <tr>
                <td>Game History</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark yes">✓</i></td>
              </tr>
              <tr>
                <td>Player Stats</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark limited">•</i></td>
              </tr>
              <tr>
                <td>Leaderboards</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark limited">•</i></td>
              </tr>

              <tr className="feature-group"><td colSpan={6}>Ease of Use</td></tr>
              <tr>
                <td>Start Game in &lt;10 sec</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>No Signup Required</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Clean Modern UI</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
              <tr>
                <td>Mobile-First Design</td>
                <td className="brand-col"><i className="mark yes">✓</i></td>
                <td><i className="mark yes">✓</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark limited">•</i></td>
                <td><i className="mark no">–</i></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="comparison-footer">
          <p>* Feature comparison based on publicly available information as of May 2026. Features may vary.</p>
          <div className="positioning-card">
            <strong>Built to run your entire poker night</strong>
            Timer, sync, discovery, tools and results — all in one.
          </div>
        </div>
      </div>
    </section>
  );
}
